"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { oaiMeasure } from "@/libs/oaiPixel";

// The OpenAI pixel does NOT track pageviews automatically — `page_viewed`
// must be fired by us. Fire on mount and on every client-side route change
// so ChatGPT Ads sees landing pages and SPA navigation.
export default function OpenAIPixelPageView(): null {
  const pathname = usePathname();

  useEffect(() => {
    oaiMeasure("page_viewed", {
      type: "contents",
      contents: [{ id: pathname, content_type: "page" }],
    });
  }, [pathname]);

  return null;
}
